import React from "react";
import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import LigneImpotDetaille from "./LigneImpot";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import "./ContexteFiscal.css";

const Divers=(props)=> {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">📂</span>
          Divers
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Autres revenus nets imposables */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📋</div>
            Autres revenus nets imposables
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "AutresRevenus"]}
              onChange={context.handleInputChange(Outil + "AutresRevenus")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Revenus soumis aux PS avec CSG déductible */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">✅</div>
            Revenus soumis aux PS avec CSG déductible
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAutresRevenusSoumisPSAvecCSGDed"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAutresRevenusSoumisPSAvecCSGDed")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Revenus soumis aux PS sans CSG déductible */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">❌</div>
            Revenus soumis aux PS sans CSG déductible
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAutresRevenusSoumisPSSansCSGDed"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAutresRevenusSoumisPSSansCSGDed")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Divers;
